import apiClient from '../api/apiClient';

const BASE = '/api/v1/admin/product-pricing-slab-matrix';

const productPricingSlabMatrixService = {
  /**
   * @param {string} productId - product UUID
   * @param {string} pricingGroupId - pricing group UUID
   */
  /**
   * @returns {Promise<{ slabs: Array, slabMatrixValid: boolean, slabMatrixError: string | null }>}
   */
  async list(productId, pricingGroupId) {
    const response = await apiClient.get(BASE, {
      params: { productId, pricingGroupId },
    });
    const body = response?.data;
    if (body?.success === false) {
      throw new Error(typeof body?.message === 'string' ? body.message : 'Failed to load slab matrix');
    }
    const d = body?.data ?? {};
    const list = d.slabs;
    return {
      slabs: Array.isArray(list) ? list : [],
      slabMatrixValid: d.slabMatrixValid !== false,
      slabMatrixError: typeof d.slabMatrixError === 'string' ? d.slabMatrixError : null,
    };
  },

  async get(uuid) {
    const response = await apiClient.get(`${BASE}/${uuid}`);
    const body = response?.data;
    if (body?.success === false) {
      throw new Error(typeof body?.message === 'string' ? body.message : 'Failed to load row');
    }
    return body?.data?.slab ?? null;
  },

  async create(payload) {
    const response = await apiClient.post(BASE, payload);
    return response?.data;
  },

  async update(uuid, payload) {
    const response = await apiClient.patch(`${BASE}/${uuid}`, payload);
    return response?.data;
  },

  async remove(uuid) {
    const response = await apiClient.delete(`${BASE}/${uuid}`);
    return response?.data;
  },
};

export default productPricingSlabMatrixService;
